
//import React, {useEffect} from 'react';
//import {useLocation} from 'react-router-dom';
import '../../components/styles_2.css';
import {useSearchParams } from 'react-router-dom';



//function useQuery() {
//  return new URLSearchParams(useLocation().search);
//}

export default function Unsubscribe() {

  const [searchParams] = useSearchParams();
  const id = searchParams.get('email');

  // Make API call with email parameter to log unsubscribe record


  return (
    <html>
      <head>
        <meta charset='UTF-8'></meta>
        <title>Athelon Marketing Group</title>
      </head>
 
      <body>
        <div class='container'>
          <div class='header'>
            <h1><i>Unsubscribe Request</i></h1>
          </div>

          <div class='body'>
            <center><h2></h2></center>
            <p>
              An unsubscribed request has been sent to the adminstrator to remove you from our email marketing list. 
              We're sorry to see you go, but we respect your decision. 
              This means you will no longer receive updates, promotions, or valuable content from us.
            </p>
            <br/>
            <p>
              The request may take up to 10 days to fully process.
            </p>
          </div>

          <div class='footer'>
            <p><i>Thank you for your patronage!</i></p>
          </div>
        </div>

      </body>

    </html>
  )
};



 
      

 
